import { IntroductionStylesVariant } from 'components/Introduction'

type ObjectWithStringValues = {
  [key: string]: string
}

interface GetPathIntroducionDataParams {
  copyIntroduction: ObjectWithStringValues
  stylesVariant: IntroductionStylesVariant
  copyIntroductionText?: ObjectWithStringValues
  useInfoAlternativeIfAvailable?: boolean
  withAlternativeTitle?: boolean
  withHeadline?: boolean
}

export const getPathIntroductionData = ({
  withAlternativeTitle,
  withHeadline,
  useInfoAlternativeIfAvailable,
  copyIntroduction,
  copyIntroductionText,
  stylesVariant
}: GetPathIntroducionDataParams) => {
  if (!copyIntroduction) {
    return { stylesVariant }
  }

  const title = withAlternativeTitle
    ? copyIntroduction.headlineAlternative
    : copyIntroduction.headline

  if (!copyIntroductionText) {
    return { title, stylesVariant }
  }

  const headline = withHeadline ? copyIntroductionText.label : undefined

  const info =
    useInfoAlternativeIfAvailable && copyIntroductionText.valueAlternative
      ? copyIntroductionText.valueAlternative
      : copyIntroductionText.value

  return { title, headline, info, stylesVariant }
}
